/**
 * OrgHome UpcomingEvents feature test-id constants
 * Generated from @fiji/common testId builder
 */
import { COMPONENTS, ELEMENTS, tid } from '@fiji/common/src/testing/testId';

export const UPCOMING_EVENTS_TEST_IDS = {
    eventListing: {
        eventIcon: tid.upcomingEvents(COMPONENTS.CARD, ELEMENTS.ICON, undefined, 'event'),
        eventIconWithName: (iconName: string) =>
            tid.upcomingEvents(COMPONENTS.TABLE, ELEMENTS.ICON, undefined, iconName),
    },
} as const;
